<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Impressão de Boletos</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 10%">Protocolo</th>
                      <th style="width: 20%">Data</th>
                      <th style="width: 30%">Pessoa</th>
                      <th style="width: 15%">Cpf/Cnpj</th>
                      <th style="width: 5%">Qtd.</th>
                      <th style="width: 20%">Situação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="even selecionavel"
                      role="row"
                      v-for="item in apiData.data"
                      :key="item.id"
                      @click="showDetalhe(item.id)"
                    >
                      <td>{{ item.id }}-{{ item.digito }}</td>
                      <td>{{ item.data | dataHoraFormatada }}</td>
                      <td>{{ item.pessoa.nome_razao }}</td>
                      <td>{{ item.pessoa.cpf_cnpj }}</td>
                      <td>{{ item.qtd_titulo }}</td>
                      <td>
                        <strong :class="item.status">{{  item.status == 'APROVADO' && item.libera_boleto != 'S' ? 'PRÉ APROVADO' : item.status }}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.</div>
                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination :limit="5" :data="apiData" v-on:pagination-change-page="getDataTable">
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
export default {
  data: () => ({
    dados: {
      filtro: ""
    },
    apiData: {
      data: []
    }
  }),
  mounted() {
    this.getDataTable();
    this.$nextTick(() => {
      // this.$refs.filtro_pesquisa.focus();
    });
  },

  methods: {
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      this.dados.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.dados;
      axios
        .get(
          `${this.$store.state.serverURI}/api/garantia/getAllPaginate`,
          config
        )
        .then(response => {
          console.log(response);
          this.apiData = response.data;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },
    showDetalhe(garantiaId) {
      this.$router.push(`/operacao/garantias/impressao/detalhe/${garantiaId}`);
    }
  },
  watch: {
    page: function(val) {
      this.getDataTable();
    }
  },

  components: {}
};
</script>
<style scoped>
.selecionavel {
  cursor: pointer;
}
.selecionavel:hover {
  background-color: #ddd;
}

td {
  text-transform: uppercase;
}

.APROVADO {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// impressao.vue?668629d5